var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12.375C5.25 11.3412 4.40883 10.5 3.375 10.5C2.34117 10.5 1.5 11.3412 1.5 12.375C1.5 13.4088 2.34117 14.25 3.375 14.25C4.40883 14.25 5.25 13.4088 5.25 12.375ZM17.25 12.375C17.25 13.4088 18.0912 14.25 19.125 14.25C20.1588 14.25 21 13.4088 21 12.375C21 11.3412 20.1588 10.5 19.125 10.5C18.0912 10.5 17.25 11.3412 17.25 12.375ZM9.375 12.375C9.375 13.4088 10.2162 14.25 11.25 14.25C12.2838 14.25 13.125 13.4088 13.125 12.375C13.125 11.3412 12.2838 10.5 11.25 10.5C10.2162 10.5 9.375 11.3412 9.375 12.375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/MoreOptions.6d4a6b66a5102ba7cfd85d8b9d12419c.svg";
export { ForwardRef as ReactComponent };